const form = {
	ContainerInfo:
		[
			{
				label: 'Container No.',
				type: 'info',
				id: 'ContainerNo',
				name: 'ContainerNo',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Container Type',
				type: 'info',
				id: 'ContainerType',
				name: 'ContainerType',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Carrier',
				type: 'info',
				id: 'Carrier',
				name: 'Carrier',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Voyage No.',
				type: 'info',
				id: 'Voyage',
				name: 'Voyage',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Port Terminal',
				type: 'combo',
				id: 'PortTerminalId',
				name: 'Port',
				class: '_align _name',
				colm: 4,
			},
			{
				label: 'Port Terminal',
				type: 'info',
				id: 'PortTerminal',
				name: 'Port',
				class: '_align _name',
				colm: 4,
			},
		],
	General:
		[
			{
				label: 'DGR',
				type: 'info',
				id: 'dgr',
				name: 'dgr',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'IMO',
				type: 'info',
				id: 'imo',
				name: 'imo',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Consignee',
				type: 'info',
				id: 'Consignee',
				name: 'Consignee',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'From',
				type: 'info',
				id: 'From',
				name: 'From',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'To',
				type: 'info',
				id: 'To',
				name: 'To',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Carrier Free Days',
				type: 'info',
				id: 'FreeDays',
				name: 'FreeDays',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Customer Free Days',
				type: 'info',
				id: 'CustomerFreeDays',
				name: 'CustomerFreeDays',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'ETD',
				type: 'info',
				id: 'ETD',
				name: 'ETD',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'ATD',
				type: 'info',
				id: 'ATD',
				name: 'ATD',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'ETA',
				type: 'info',
				id: 'ETA',
				name: 'ETA',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'ATA',
				type: 'info',
				id: 'ATA',
				name: 'ATA',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Max Empty Return',
				type: 'info',
				id: 'MaxEmptyReturned',
				name: 'MaxEmptyReturned',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Max Carrier Empty',
				type: 'info',
				id: 'MaxCarrierEmptyReturned',
				name: 'MaxCarrierEmptyReturned',
				class: '_align _name',
				colm: 2,
			}, {
				label: 'Out Of Gate',
				type: 'info',
				id: 'OutGate',
				name: 'OutGate',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Delivery at Destination',
				type: 'info',
				id: 'DeliveryDestination',
				name: 'DeliveryDestination',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Actual Empty Return',
				type: 'info',
				id: 'EmptyReturned',
				name: 'EmptyReturned',
				class: '_align _name',
				colm: 2,
			},
		],
	Cargo:
		[
			{
				label: 'Dimensions',
				type: 'info',
				id: 'Dimensions',
				name: 'Dimensions',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Total Pieces',
				type: 'info',
				id: 'TotalPieces',
				name: 'TotalPieces',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Total Weight',
				type: 'info',
				id: 'TotalWeight',
				name: 'TotalWeight',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Total Volume',
				type: 'info',
				id: 'TotalVolume',
				name: 'TotalVolume',
				class: '_align _name',
				colm: 2,
			},
			{
				label: 'Cargo Description',
				type: 'info',
				id: 'Cargo',
				name: 'Cargo',
				class: '_align _name',
				colm: 2,
			},
		],
	Incident:
		[
			{
				label: 'Incident Type',
				type: 'combo',
				id: 'incidenttype',
				name: 'incidenttype',
				class: '_align _name',
				colm: 6,
			},
			{
				label: 'Incident Type',
				type: 'info',
				id: 'incidenttypeId',
				name: 'incidenttypeId',
				class: '_align _name',
				colm: 6,
			},
			{
				label: 'Incident Date',
				type: 'info',
				id: 'IncidentDateInfo',
				name: 'IncidentDateInfo',
				class: '_align _name',
				colm: 6,
			},
			{
				label: 'Additional Comments',
				type: 'info',
				id: 'AdditionalCommentInfo',
				name: 'AdditionalCommentInfo',
				class: '_align _name',
				colm: 12,
			},
			{
				label: 'Created by',
				type: 'info',
				id: 'CreateUser',
				name: 'CreateUser',
				class: '_align _name',
				colm: 6,
			},
			{
				label: 'Creation Date',
				type: 'info',
				id: 'CreateDay',
				name: 'CreateDay',
				class: '_align _name',
				colm: 6,
			},
		],
	CreateIncident:
		[
			{
				label: 'Select the type of Incident',
				type: 'combo',
				id: 'IncidentType',
				name: 'IncidentType',
				class: '_align _name',
				colm: 12,
			},
			{
				label: 'Select Cause of Sinister',
				type: 'combo',
				id: 'SiniesterId',
				name: 'SiniesterId',
				class: '_align _name',
				colm: 12,
			},
			{
				label: 'Incident Date',
				type: 'date',
				id: 'IncidentDate',
				name: 'IncidentDate',
				class: '_align _name',
				colm: 12,
			},
			// {
			// 	label: 'Abandoned Date',
			// 	type: 'date',
			// 	id: 'IncidentDate',
			// 	name: 'IncidentDate',
			// 	class: '_align _name',
			// 	colm: 12,
			// },
			// {
			// 	label: 'Sinester Date',
			// 	type: 'date',
			// 	id: 'IncidentDate',
			// 	name: 'SinesterDate',
			// 	class: '_align _name',
			// 	colm: 12,
			// },
			{
				label: 'Additional Comment',
				type: 'text-area',
				id: 'AdditionalComment',
				name: 'AdditionalCommentM',
				class: '_align _name',
				colm: 12,
			},
		],
};

export default form;